import React, { useState, useEffect } from "react";
import LoadingData from "../../Common/LoadingData";

const Pricing = () => {
  const [count, setCount] = useState(0);
  const [pending, setPending] = useState(false);
  const [pricing, setPricing] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleList = (e, index, itemIndex) => {
    setPricing([
      ...pricing.map((item, i) => {
        if (i === index) {
          return {
            ...item,
            list: item.list.map((ele, i) => {
              if (i === itemIndex) {
                return e.target.value;
              } else {
                return ele;
              }
            }),
          };
        } else {
          return item;
        }
      }),
    ]);
  };

  const handleDeleteElement = (index, iEle) => {
    setPricing([
      ...pricing.map((item, i) => {
        if (index === i) {
          return {
            ...item,
            list: item.list.filter((_, ind) => ind !== iEle),
          };
        } else {
          return item;
        }
      }),
    ]);
  };

  const handelMoreList = (index) => {
    pricing.map((item, i) => {
      if (i === index) {
        return (
          item.list.push(""),
          setCount([
            ...count.map((ele, x) => {
              if (x === index) {
                return ele + 1;
              } else {
                return ele;
              }
            }),
          ])
        );
      } else {
        return item;
      }
    });
  };

  const handelSubmit = (e) => {
    e.preventDefault();
    setPending(true);

    fetch(`${process.env.REACT_APP_BASE_URL}/plans`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(pricing),
    })
      .then((res) => res.json())
      .then((data) => {
        // console.log(data);
        setPending(false);
      });
  };

  useEffect(() => {
    // setLoading(true);
    fetch(`${process.env.REACT_APP_BASE_URL}/plans`, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          const dataPricing = [...data.msg].map((ele) => {
            return {
              name: ele.name,
              list: ele.list,
              _id: ele._id,
              price: ele.price,
            };
          });
          setPricing(dataPricing);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (pricing.length) {
      const num = pricing?.map((item) => item?.list?.length);
      setCount(num);
    }
  }, [pricing]);

  // if (loading) {
  //   return <LoadingData />;
  // }

  return (
    loading ? (
      <div style={{ width: "", textAlign: "center", marginTop: "300px" }}>
        <div className="lds-dual-ring"></div>
      </div>
    ) :
    <section className="Pricing mt-4">
      <div className="container">
        <div className="row">
          <div className="col-md-6 m-auto">
            <div className="section-body">
              <form onSubmit={handelSubmit}>
                {pricing.map((item, index) => (
                  <div className="pricing-box" key={index}>
                    <div className="pricing-header">
                      <h6 className="mb-3">{item.name}</h6>
                      <div className="pricing-price d-flex align-items-center mb-3">
                        <span>$</span>
                        <input
                          type="number"
                          className="form-control"
                          min="0"
                          value={item.price}
                          onChange={(e) =>
                            setPricing([
                              ...pricing.map((ele, i) => {
                                if (i === index) {
                                  return {
                                    ...ele,
                                    price: e.target.value,
                                  };
                                } else {
                                  return ele;
                                }
                              }),
                            ])
                          }
                        />
                      </div>
                      <div className="pricing-features">
                        {Array(count[index])
                          .fill()
                          .map((_, i) => (
                            <div
                              className="d-flex align-items-center w-100 justify-content-center"
                              key={i}
                            >
                              <div className="pricing-feature mb-3 w-100">
                                <input
                                  type="text"
                                  className="form-control"
                                  value={item.list[i]}
                                  onChange={(e) => handleList(e, index, i)}
                                />
                              </div>
                              <div className="pricing-btn mb-3">
                                <button
                                  type="button"
                                  className="btn danger"
                                  onClick={() => handleDeleteElement(index, i)}
                                >
                                  <i className="fa fa-minus"></i>
                                </button>
                              </div>
                            </div>
                          ))}
                      </div>
                      <div className="pricing-btn-more mb-5">
                        <button
                          className="btn btn-primary"
                          type="button"
                          onClick={() => handelMoreList(index)}
                        >
                          <i className="fas fa-plus"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
                <div>
                  <button
                    className="contButSmall"
                    type="submit"
                    aria-label="save"
                    data-toggle="tooltip"
                    title="save"
                    disabled={pending}
                  >
                    {pending ? (
                      <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                    ) : (
                      <span>save</span>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
